<template>
    <modal name="proveedor-modal" :scrollable="true" :width="700" :height="800">
      <div class="modal-content modalContent">
        <span class="closebtn" @click="closeModal">&times;</span>
      </div>
      <div class="p-3">
        <div class="text-center">
          <h4 class="with-lines">Proveedores</h4>
        </div>
        <div class="">
          <div class="row">
            <div class="col-10">
              <input
                class="form-control"
                v-model="search"
                @keyup.enter="searchProveedor"
                placeholder="Buscar..."
              />
            </div>
            <div class="col-2">
              <button @click="searchProveedor" type="button" class="btn btn-light container">
                <i class="fal fa-search"></i>
              </button>
            </div>
          </div>
  
          <div class="list-group mt-3">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Proveedor</th>
                  <th scope="col">RFC</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="proveedor"
                  v-for="(prov, i) in paginatedData"
                  :key="i"
                  @click="selectProveedor(prov.CveProveedor, prov.Proveedor, prov.RFC)"
                  :class="{ selectedItem: prov.CveProveedor === idProv }"
                >
                  <td>{{ prov.Proveedor }}</td>
                  <td>{{ prov.RFC }}</td>
                </tr>
              </tbody>
            </table>
          </div>
  
          <!-- Paginador -->
          <div class="pagination">
            <button @click="setPage(1)" :disabled="currentPage === 1">Primera</button>
            <button @click="prevPage" :disabled="currentPage === 1">Anterior</button>
            
            <span v-if="startPage > 1">...</span>
            
            <button
              v-for="page in visiblePages"
              :key="page"
              @click="setPage(page)"
              :class="{ active: currentPage === page }"
            >
              {{ page }}
            </button>
            
            <span v-if="endPage < totalPages">...</span>
  
            <button @click="nextPage" :disabled="currentPage === totalPages">Siguiente</button>
            <button @click="setPage(totalPages)" :disabled="currentPage === totalPages">Última</button>
          </div>
        </div>
      </div>
    </modal>
  </template>
  
  <script>
  export default {
    props: {
      search: String,
      datosPaginados: Array,
      idProv: Number,
      nomProv: String,
      RFCProv: String
    },
    computed: {
      paginatedData() {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.datosPaginados.slice(start, end);
      },
      totalPages() {
        return Math.ceil(this.datosPaginados.length / this.itemsPerPage);
      },
      startPage() {
        return Math.max(1, this.currentPage - 2);
      },
      endPage() {
        return Math.min(this.totalPages, this.currentPage + 2);
      },
      visiblePages() {
        let pages = [];
        for (let i = this.startPage; i <= this.endPage; i++) {
          pages.push(i);
        }
        return pages;
      }
    },
    methods: {
      closeModal() {
        this.$modal.hide('proveedor-modal');
      },
      searchProveedor() {
        this.$emit('update:search', this.search);
        this.$emit('search-proveedor'); // Emitir evento para buscar proveedores
      },
      nextPage() {
        if (this.currentPage < this.totalPages) {
          this.currentPage += 1;
        }
      },
      prevPage() {
        if (this.currentPage > 1) {
          this.currentPage -= 1;
        }
      },
      setPage(page) {
        this.currentPage = page;
      },
      selectProveedor(id, nombre, rfc) {
        this.$emit('select-proveedor', { id, nombre, rfc });
        setTimeout( () => {
            this.$modal.hide('proveedor-modal');
            this.successMessage = 'Proveedor seleccionado.'
            this.$modal.show('success-modal');
        },400)
        setTimeout( () => {
            this.$modal.hide('success-modal');
        },1500)
      }
    },
    watch: {
      search(newVal) {
        this.localProveedor = newVal;
      }
    },
    data() {
      return {
        localProveedor: this.search,
        currentPage: 1,
        itemsPerPage: 10,
      };
    },
  };
  </script>
  
  <style scoped>
   .scrollable-content {
    max-height: 500px;
    overflow-y: auto;
  }
  
  .selectedItem {
    background-color: #007bff;
    color: white;
  }
  
  .with-lines {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  
  .with-lines::before,
  .with-lines::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #003c717a;
    margin: 0 10px;
  }
  
  .closebtn {
    position: absolute;
    top: 10px;
    right: 15px;
    color: #003c71;
    font-weight: bold;
    font-size: 22px;
    line-height: 20px;
    cursor: pointer;
    transition: 0.3s;
  }
  
  .closebtn:hover {
    color: #003c718c;
  }
  
  .pagination {
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }
  
  .pagination button {
    margin: 0 5px;
    padding: 5px 10px;
    background-color: #007bff;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 3px;
    transition: background-color 0.3s;
  }
  
  .pagination button:disabled {
    background-color: #cccccc;
    cursor: pointer;
  }
  
  .pagination button.active {
    background-color: #0056b3;
    cursor: pointer;
  }
  
  .pagination button:hover:not(:disabled) {
    background-color: #0056b3;
  }
  </style>
  